import React from 'react';
import {
  Stack,
  Heading,
  Flex,
  Text,
  Box,
  useColorModeValue,
  Progress,
} from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';

const formatCurrency = (value) => {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value);
};

const RankingClientes = ({ data }) => {
  const bgItem = useColorModeValue('gray.50', 'gray.800');
 // const bgTop1 = useColorModeValue('yellow.100', 'yellow.700');

  // Obtener el valor más alto de ventas
  const maxTotal = data.length > 0 ? Math.max(...data.map((c) => c.totalGeneral)) : 1;

  return (
    <Stack
      boxShadow="base"
      bg="white"
      _dark={{ bg: 'primary.1000' }}
      rounded="2xl"
      p={4}
      spacing={4}
    >
      <Heading fontSize="lg">
        Ranking de Ventas por Cliente - {new Date().getFullYear()}
      </Heading>

      {data && data.length > 0 ? (
        data.map((cliente, index) => {
          const porcentaje = Math.round((cliente.totalGeneral / maxTotal) * 100);
          return (
            <Box
              key={cliente.idCliente}
              p={3}
              borderRadius="md"
              bg={index === bgItem}
            >
              <Flex align="center" justify="space-between">
                <Box>
                  <Text fontWeight="bold">
                    # {index + 1} {cliente.cliente}
                  </Text>
                
                </Box>
                <Flex align="center" gap={2}>
                  {index === 0 && <StarIcon color="yellow.400" />}
                  <Text fontWeight="bold" color="green.500">
                    {formatCurrency(cliente.totalGeneral)}
                  </Text>
                </Flex>
              </Flex>
              <Progress
                mt={2}
                value={porcentaje}
                size="sm"
                colorScheme="green"
                borderRadius="md"
              />
            </Box>
          );
        })
      ) : (
        <Text color="gray.500">No hay datos para mostrar.</Text>
      )}
    </Stack>
  );
};

export default RankingClientes;
